import {
  ChannelConsentState,
  PREFERENCE_FORM_CHANNEL_OPTIONS,
} from '../types/subscribers';

type ChannelPreferencePickerProps = {
  label: string;
  description: string;
  value: ChannelConsentState;
  onChange: (value: ChannelConsentState) => void;
};

function ChannelPreferencePicker({
  label,
  description,
  value,
  onChange,
}: ChannelPreferencePickerProps) {
  return (
    <fieldset
      data-testid={`channel-picker-${label.toLowerCase()}`}
      className="rounded-lg border border-gray-200 p-4"
    >
      <legend className="px-1 font-fustat-bold text-sm text-gray-900">{label}</legend>
      <p className="mb-3 text-sm text-gray-600 font-fustat">{description}</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {PREFERENCE_FORM_CHANNEL_OPTIONS.map((option) => {
          const selected = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              data-testid={`channel-option-${option.value}`}
              aria-pressed={selected}
              onClick={() => onChange(option.value)}
              className={`rounded-lg border px-3 py-3 text-left transition-colors ${
                selected
                  ? 'border-primary bg-primary/5 ring-1 ring-primary'
                  : 'border-gray-200 bg-white hover:border-gray-300'
              }`}
            >
              <span className="block font-fustat-medium text-sm text-gray-900">
                {option.label}
              </span>
              <span className="mt-1 block text-xs text-gray-500 font-fustat">
                {option.description}
              </span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}

export default ChannelPreferencePicker;
